module.exports = __webpack_public_path__ + "img/video.59dbfbef.svg";